// extracted by mini-css-extract-plugin
module.exports = {"outer":"hero_outer__23SU4","inner":"hero_inner__2NkEK","text":"hero_text__3oP5j"};